module.exports = __webpack_public_path__ + "img/Veranza-27-min.1ebf5ba8.jpg";